import { render, staticRenderFns } from "./GhostFilter.vue?vue&type=template&id=5fc3a5d9&scoped=true&lang=pug&"
import script from "./GhostFilter.vue?vue&type=script&lang=js&"
export * from "./GhostFilter.vue?vue&type=script&lang=js&"
import style0 from "./GhostFilter.vue?vue&type=style&index=0&id=5fc3a5d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc3a5d9",
  null
  
)

export default component.exports